import React, { useEffect, useState } from 'react';
import { getQualityTaskInfo } from '../util/api';
import { useParams } from 'react-router-dom';
import { message, Row, Col, Table, Image } from 'antd';
import { useHistory } from 'react-router-dom';
import '../qualityGradient/index.less';
import './detail.less';
import moment from 'moment';
const QualityTaskDetail = () => {
  const params = useParams();
  const history = useHistory();
  const [info, setInfo] = useState({});
  const STATUS = {
    1: '合格',
    2: '退货',
    3: '换货',
    4: '扣收'
  };
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      align: 'center',
    },
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      align: 'center',
    },
    {
      title: '商品单位',
      dataIndex: 'item_unit',
      align: 'center',
    },
    {
      title: '到货数量',
      dataIndex: 'arrival_number',
      align: 'center',
    },
    {
      title: '抽检率',
      dataIndex: 'sampling_rate',
      align: 'center',
      render: (val) => (val + '%') ?? ''
    },
    {
      title: '抽检数量/重量',
      dataIndex: 'sampling_number',
      align: 'center',

    },
    {
      title: '不合格重量/数量',
      dataIndex: 'unqualified_number',
      align: 'center',
    },
    {
      title: '不合格比例',
      dataIndex: 'unqualified_rate',
      align: 'center',
      render: (val) => (val + '%') ?? ''
    },
    {
      title: '现场图片',
      dataIndex: 'scene_images',
      align: 'center',
      render: (arr = [], record) => {
        return (
          <Image.PreviewGroup>
            {
              Array.isArray(arr) && arr.map(item => {
                return <Image width={50} height={50} alt='' style={{ display: 'inline-block', marginRight: 8 }} key={item.url} src={item.thumb_url} preview={{
                  src: item.url
                }} />;
              })
            }
          </Image.PreviewGroup>
        );
      }
    },
    {
      title: '处理方式',
      dataIndex: 'handling_type',
      align: 'center',
      render: (val) => {
        return STATUS[+val];
      }
    },
    {
      title: '退/换/扣数量',
      dataIndex: 'abnormal_number',
      align: 'center',
    },
    {
      title: '具体原因',
      dataIndex: 'abnormal_reason',
      align: 'center',
      width: 100
    },
    {
      title: '供应商',
      dataIndex: 'supplier_name',
      align: 'center',
      width: 100
    },
    {
      title: '糖度检测',
      dataIndex: 'brix',
      align: 'center',
      width: 100
    },
    {
      title: '采购员',
      dataIndex: 'purchaser',
      align: 'center',
      width: 100
    },
    {
      title: '质检员',
      dataIndex: 'qualityer',
      align: 'center',
    },
    {
      title: '抽检次数',
      dataIndex: 'quality_number',
      align: 'center',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: 100
    },
  ];
  useEffect(() => {
    async function getInfo() {
      const res = await getQualityTaskInfo({
        id: params.id
      });
      const { code, data = {}, msg } = res.data || {};
      if (code === 0) {
        setInfo(data);
        // console.log(data);
      } else {
        message.error(msg);
      }
    };
    getInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div >
      <div style={{ display: 'flex', fontSize: '20px', fontWeight: '500', margin: '10px 0', }}>
        <span style={{ textDecoration: 'underline', cursor: 'pointer', color: '#1890FF', }} onClick={() => history.go(-1)}>质检记录</span><span>/详情页</span>
      </div>
      <div style={{ marginTop: 24 }}>
        <div>{info?.create_time ? moment(info?.create_time).format('YYYY年MM月DD日') : ''}质检情况：</div>
        <div style={{ marginTop: 24 }}>
          <div style={{ color: '#1890FF' }}>总体指标：</div>
          <Row gutter={24}>
            <Col style={{ marginTop: 20 }}>商品数量：{info.products_count}</Col>
            <Col style={{ marginTop: 20 }}>合格率：{info.type_rate_1 === '-' ? info.type_rate_1 : `${info.type_rate_1}%`}</Col>
            <Col style={{ marginTop: 20 }}>退货率：{info.type_rate_2 === '-' ? info.type_rate_2 : `${info.type_rate_2}%`}</Col>
            <Col style={{ marginTop: 20 }}>换货率：{info.type_rate_3 === '-' ? info.type_rate_3 : `${info.type_rate_3}%`}</Col>
            <Col style={{ marginTop: 20 }}>扣重收货率：{info.type_rate_4 === '-' ? info.type_rate_4 : `${info.type_rate_4}%`}</Col>
          </Row>
        </div>
        <div style={{ marginTop: 24 }}>
          <div style={{ color: '#1890FF' }}>品类指标：</div>
          <Row gutter={24}>
            {
              Array.isArray(info.category_index) && info.category_index.length > 0 &&
              info.category_index.map((item, i) => {
                return <Col span={12} style={{ margin: '22px 0' }} key={i}>
                  {item.category_name}抽检{item.products_count}个单品：
                  {
                    item.abnormal.map((item, k) => {
                      return <span key={k}>{item.abnormal_type}{item.abnormal_couont}个SKU,</span>;
                    })
                  }
                  <span> 合格率{item.pass_rate}%</span>
                </Col>;
              })
            }
          </Row>
        </div>
        <div style={{ marginTop: 24 }}>
          <div style={{ color: '#1890FF' }}>商品指标：</div>
          <Table bordered scroll={{ x: 2200 }} className='quality-table-cell' columns={columns} dataSource={info?.products} pagination={false} rowKey={'id'} />
        </div>
      </div>
    </div>
  );
};

export default QualityTaskDetail;
